module.exports = __webpack_public_path__ + "img/EScoutCavalry64_ua.e9eef1ec.webp";